import { Flex, Table, Tbody } from '@chakra-ui/react';
import { SkeletonTable } from 'src/components/SkeletonTable/SkeletonTable';
import { DaysOfWeek, ScheduleWeek } from '@/model';
import { ApplicationCalendarWeekScheduleTableRow } from './ApplicationCalendarWeekScheduleTableRow';
import { ApplicationCalendarWeekScheduleNewItemTableRow } from './ApplicationCalendarWeekScheduleNewItemTableRow';
import { ApplicationCalendarWeekScheduleHeader, labels } from './ApplicationCalendarWeekScheduleHeader';

export type NewScheduleWeek = { days_of_week: DaysOfWeek | ''; description: string };

export interface ApplicationCalendarMatchesTableProps {
  items: ScheduleWeek[];
  newItems: NewScheduleWeek[];
  isLoading?: boolean;
  onSaveClick?: (item: ScheduleWeek) => void;
  onDeleteClick?: (item: ScheduleWeek) => void;
  onNewItemSaveClick?: (newItem: NewScheduleWeek) => void;
  onNewItemDeleteClick?: (newItemIndex: number) => void;
}

export const ApplicationCalendarMatchesTable = ({
  items,
  onSaveClick,
  onDeleteClick,
  newItems,
  onNewItemSaveClick,
  onNewItemDeleteClick,
  isLoading,
}: ApplicationCalendarMatchesTableProps) => {
  return (
    <Flex overflow='auto'>
      <Table variant='striped'>
        <ApplicationCalendarWeekScheduleHeader />
        <Tbody>
          {isLoading ? (
            <SkeletonTable cols={labels?.length ?? 0} />
          ) : (
            <>
              {newItems?.map((_, index) => (
                <ApplicationCalendarWeekScheduleNewItemTableRow
                  key={index}
                  index={index}
                  items={items}
                  onSaveClick={onNewItemSaveClick}
                  onDeleteClick={onNewItemDeleteClick}
                />
              ))}

              {items?.map(item => (
                <ApplicationCalendarWeekScheduleTableRow
                  key={item?.uuid}
                  item={item}
                  onSaveClick={onSaveClick}
                  onDeleteClick={onDeleteClick}
                />
              ))}
            </>
          )}
        </Tbody>
      </Table>
    </Flex>
  );
};
